import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoService } from "./video.service";
import { HttpClientModule } from "@angular/common/http";
import { VideoPlayerComponent } from './video-player/video-player.component';
import { PhotoViewerComponent } from "./photo-viewer/photo-viewer.component";
import { EllipsisComponent } from './ellipsis/ellipsis.component';
import { PhotoService } from "./photo.service";

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule
    ],
    providers: [
        VideoService,
        PhotoService
    ],
    declarations: [
        VideoPlayerComponent,
        PhotoViewerComponent,
        EllipsisComponent
    ],
    exports: [
        VideoPlayerComponent,
        PhotoViewerComponent,
        EllipsisComponent
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [],
        }
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/shared/shared.module.ts